"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = default_1;
const Project_1 = require("../../models/Project");
const either_1 = require("../../types/either");
function default_1(project, action) {
  var _a;
  project.contactGroupId = (_a = action.contactGroupId) !== null && _a !== void 0 ? _a : '';
  project.product.options['envelope_addressing'] = (0, Project_1.getEnvelopeAddressingProductOptionValue)(project);
  return (0, either_1.right)(project);
}